import React from 'react'
import PropTypes from 'prop-types'

import { DangerTextButton } from '../../LegacyButtons'
import { ConfirmationDialog } from '@scoir/modals'

import api from 'common/api'

export class Modal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    eventId: PropTypes.string.isRequired,
    onEventChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }
  unregister() {
    const { eventId, onClose, onEventChange } = this.props
    api.delete(`/api/highschools/visits/${eventId}/register`).then(() => {
      onEventChange()
      onClose()
    })
  }
  render() {
    return (
      <ConfirmationDialog
        open={this.props.show}
        headerText="Unregister from event"
        onClose={this.props.onClose}
        onConfirm={() => {
          this.unregister()
        }}
      >
        <span>
          Are you sure you want to unregister from this event? If you change your mind, you can register again.
        </span>
      </ConfirmationDialog>
    )
  }
}
export class Trigger extends React.Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
  }
  render() {
    return (
      <DangerTextButton
        variant="text"
        size="small"
        onClick={this.props.onOpen}
      >
        Unregister
      </DangerTextButton>
    )
  }
}
